import React, { useEffect, useState } from "react";
import { Container, Col } from "react-bootstrap";
import FooterStyles from "./Footer.styles";
import AppMedia from "../../theme/utils/AppMedia";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { useParams } from "react-router-dom";
import PageUtils from "../page/Page.utils";

const { Media } = AppMedia;

interface FooterLink {
  key: string;
  text: string;
  address: string;
}

const FOOTER: React.FC = () => {
  const sendDataToGTM = useGTMDispatch();
  const { projectId }: { projectId: string } = useParams();
  const [isDetailsPage, setIsDetailsPage] = useState<boolean>(false);

  useEffect(() => {
    // istanbul ignore next
    if (projectId) {
      setIsDetailsPage(true);
    } else {
      setIsDetailsPage(false);
    }
  }, [projectId]);

  const links: FooterLink[] = [
    {
      key: "privacy",
      text: "Privacy",
      address: "https://www.consumersenergy.com/privacy",
    },
    {
      key: "contact",
      text: "Contact",
      address: "https://www.consumersenergy.com/contact-us",
    },
    {
      key: "termsofuse",
      text: "Terms of Use",
      address: "https://www.consumersenergy.com/terms-and-conditions",
    },
    {
      key: "security",
      text: "Security",
      address: "https://www.consumersenergy.com/security",
    },
  ];

  const mobileElements = links.map((link) => {
    return (
      <FooterStyles.StyledFooterCEText key={link.key}>
        <Col>
          <FooterStyles.BarlessLink
            href={link.address}
            onClick={
              /* istanbul ignore next */ () => {
                sendDataToGTM({
                  event: "eventTracking",
                  category: "Construction",
                  action: "Click - Footer",
                  label: `${link.text} ${PageUtils.getGTMPageLabel(
                    isDetailsPage
                  )}`,
                });
              }
            }
          >
            {link.text}
          </FooterStyles.BarlessLink>
        </Col>
      </FooterStyles.StyledFooterCEText>
    );
  });

  const desktopElements = links
    .map((link) => {
      return (
        <FooterStyles.BarlessLink
          key={link.key}
          href={link.address}
          onClick={
            /* istanbul ignore next */ () => {
              sendDataToGTM({
                event: "eventTracking",
                category: "Construction",
                action: "Click - Footer",
                label: `${link.text} ${PageUtils.getGTMPageLabel(
                  isDetailsPage
                )}`,
              });
            }
          }
        >
          {link.text}
        </FooterStyles.BarlessLink>
      );
    })
    .reduce((x, y) => {
      return (
        <>
          {x} | {y}
        </>
      );
    });

  const CopywriteTextElement = () => {
    return (
      <>
        <Col>&copy;2022 Consumers Energy</Col>
      </>
    );
  };

  const Factory: React.FC = () => {
    return (
      <Container fluid>
        <Media greaterThanOrEqual="tablet">
          <FooterStyles.StyledFooterCEText>
            <CopywriteTextElement />
          </FooterStyles.StyledFooterCEText>
          <FooterStyles.StyledFooterCEText>
            <Col lg={12} md={12}>
              {desktopElements}
            </Col>
          </FooterStyles.StyledFooterCEText>
        </Media>
        <Media lessThan="tablet">
          <FooterStyles.StyledFooterCEText>
            <CopywriteTextElement />
          </FooterStyles.StyledFooterCEText>
          {mobileElements}
        </Media>
      </Container>
    );
  };

  return (
    <>
      <FooterStyles.FooterDivider
        className="ce-CSSO-footer-divider"
        data-testid="footer-divider"
      />
      <Media greaterThanOrEqual="computer">
        <FooterStyles.FooterContentDesktop className="ce-CSSO-footer-content">
          <Factory />
        </FooterStyles.FooterContentDesktop>
      </Media>
      <Media at="tablet">
        <FooterStyles.FooterContentTablet className="ce-CSSO-footer-content">
          <Factory />
        </FooterStyles.FooterContentTablet>
      </Media>
      <Media lessThan="tablet">
        <FooterStyles.FooterContentMobile className="ce-CSSO-footer-content">
          <Factory />
        </FooterStyles.FooterContentMobile>
      </Media>
    </>
  );
};

export default FOOTER;
